<template>
    <el-row>
      <el-col :span="24">

        <br />

        <h2>Sharers Summary</h2>
        <sharers-bar-chart v-if="sharers.length >= 0" :sharer-data="sharers" />

        <xolas-table
          hide-org-badge
          table-ref="sharingtable"

          title=""
          icon="fa fa-users"

          url="stats/org/20/null/telco"

          sort-field="sitesTotal"
          sort-direction="desc"
          :show-search="false"

          :fields="fields"

          track-by="organisation_id">

          <template #details="scope">
            <popup-sharer-stats :row-data="scope.rowData" />
          </template>

        </xolas-table>

    </el-col>
  </el-row>

</template>


<script>

import PostMixins from '@/mixins/PostMixins'

import SharersBarChart from '@/components/dashboard/charts/SharersBarChart'
import PopupSharerStats from '@/components/dashboard/sharers/PopupSharerStats'


export default {

  mixins: [PostMixins],

  components: {
    PopupSharerStats,
    SharersBarChart
  },



  props: {

    hideOrgBadge: {
      type: Boolean,
      default: false
    },

    titleClass: {
      type: String,
      default: null
    }

  },


  methods: {

    processData(data) {
      this.sharers = data
    }

  },


  data () {
    return {
      sharers: [],
      // minWidth hints mirror the pre-migration vuetable-2 render, measured at
      // 1504px viewport (.context/xol-234-baselines/metrics.json,
      // sharing-summary-report[0]) — el-table distributes un-sized columns
      // equally, which does not match the legacy content-based auto layout.
      // '__slot:details' baseline width rounds to 0 (an unlabelled popup-details
      // trigger cell) — no minWidth added.
      fields: [
        {
          title: 'Name',
          name: 'shortName',
          minWidth: 69
        },
        {
          title: 'Total',
          name: 'sitesTotal',
          titleClass: 'text-black',
          dataClass: 'text-black',
          minWidth: 57
        },
        {
          title: '% sites',
          name: 'percentSites',
          titleClass: 'hidden-sm-and-down text-info',
          dataClass: 'hidden-sm-and-down text-center text-info',
          minWidth: 78
        },
        {
          title: 'Active',
          name: 'sitesActive',
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-center text-primary',
          minWidth: 72
        },
        {
          title: 'New',
          name: 'sitesNew',
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-center text-success',
          minWidth: 52
        },
        {
          title: 'Exclusive',
          name: 'sitesExclusive',
          titleClass: 'hidden-md-and-down text-black',
          dataClass: 'hidden-md-and-down text-center text-black',
          minWidth: 108
        },
        {
          title: 'Canditate',
          name: 'sitesCanditate',
          titleClass: 'hidden-md-and-down text-warning',
          dataClass: 'hidden-md-and-down text-center text-warning',
          minWidth: 111
        },
        {
          title: 'Dismantled',
          name: 'sitesDismantled',
          titleClass: 'hidden-md-and-down text-danger',
          dataClass: 'hidden-md-and-down text-center text-danger',
          minWidth: 132
        },
        {
          title: 'Temporary',
          name: 'sitesTemporary',
          titleClass: 'hidden-md-and-down text-info',
          dataClass: 'hidden-md-and-down text-center',
          minWidth: 125
        },
        {
          title: 'Ratio %',
          name: 'sharingRatio',
          sortField: 'sharingRatio',
          minWidth: 83
        },
        {
          name: '__slot:details'
        }
      ]
    }
  },

  created () {
    this.fetchData('stats/org/20/null/telco', this.processData)
  }


}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
